export {};
declare global {
    interface Uint8Array {
        toBase64(): string;
        toBase64Url(): string;
    }
}

if (!Uint8Array.prototype.toBase64) {
    Uint8Array.prototype.toBase64 = function toBase64(
        this: Uint8Array,
    ): string {
        return window.btoa(String.fromCharCode(...this));
    };
}

if (!Uint8Array.prototype.toBase64Url) {
    Uint8Array.prototype.toBase64Url = function toBase64Url(
        this: Uint8Array,
    ): string {
        return this.toBase64()
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    };
}
